import AdminMessagesController from "./admin-messages-controller";
import { connect } from "react-redux";
import { getValue } from "store/languages";
import { getMessages } from "store/landing"
import { setItemsCount, setCurrentPage, setShowedItemsCount, setToDefaultPaginator } from "store/paginator";

let mapStateToProps = (state) => {
    return {
        messages: state.LandingMenu.messages,
        messagesHeader: state.LandingMenu.messagesHeader,
        currentPage: state.paginator.currentPage,
        count: state.LandingMenu.count,
        page: state.LandingMenu.page,
        showedItemsCount: state.paginator.showedItemsCount,
    }
}

const AdminMessagesContainer = connect(mapStateToProps, { 
                                                            getValue,
                                                            getMessages
                                                        })
                                                        (AdminMessagesController);

export default AdminMessagesContainer;